import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DashboardHeader from "../../../components/dashboard/dashboardHeader";
import ReportGuideTemplateEditor from "../../../components/dashboard/service/settings/ReportGuideTemplateEditor";
import { fetchReportTypes } from "../../../api/service/settings";
import { ResourceLoading } from "../../../components/utils/ResourceLoading";

export const ServiceReportGuides = () => {
  const { t } = useTranslation();
  const [reportTypesState, setReportTypesState] = useState({
    isLoading: true,
    data: [],
  });
  const [scope, setScope] = useState("general");

  useEffect(() => {
    fetchReportTypes({
      filters: [],
      page: 1,
      per_page: 100,
      query: "",
      sort: "asc",
      sortBy: "title",
      view: "all",
    })
      .then((response) => {
        setReportTypesState({
          isLoading: false,
          data: response?.data || [],
        });
      })
      .catch(() => setReportTypesState({ isLoading: false, data: [] }));
  }, []);

  const selectedReportType = useMemo(
    () => reportTypesState.data.find((item) => String(item.id) === String(scope)),
    [reportTypesState.data, scope]
  );
  const generalOnly = scope === "general";

  return (
    <DashboardHeader
      variant="v2"
      title={t("Rapportguider")}
      subtitle={t("Opprett og rediger guidede flyter for rapportarbeid.")}
      backUrl="/dashboard/service/settings"
      actions={[]}
      meta={[]}
    >
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="mb-5 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <h2 className="text-base font-semibold text-slate-950">{t("Guideomfang")}</h2>
              <p className="mt-1 text-sm text-slate-600">
                {t("Velg om du vil redigere generelle rapportguider eller guider for en spesifikk rapporttype.")}
              </p>
            </div>
            <Link
              to="/dashboard/service/settings"
              className="inline-flex items-center justify-center rounded-md border border-slate-200 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
            >
              {t("Tilbake til serviceinnstillinger")}
            </Link>
          </div>

          {reportTypesState.isLoading ? (
            <div className="mt-4">
              <ResourceLoading />
            </div>
          ) : (
            <select
              value={scope}
              onChange={(event) => setScope(event.target.value)}
              className="mt-4 block w-full max-w-xl rounded-md border-gray-300 text-sm shadow-sm focus:border-sky-500 focus:ring-sky-500"
            >
              <option value="general">{t("Generelle rapportguider")}</option>
              {reportTypesState.data.map((reportType) => (
                <option key={reportType.id} value={reportType.id}>
                  {reportType.title || reportType.displayTitle}
                </option>
              ))}
            </select>
          )}
        </div>

        {!reportTypesState.isLoading ? (
          <ReportGuideTemplateEditor
            key={scope}
            generalOnly={generalOnly}
            reportType={generalOnly ? null : selectedReportType}
          />
        ) : null}
      </div>
    </DashboardHeader>
  );
};
